export const SHARED_LIB_IMPORT_PATH = "common.py";
